export enum TRASecurityModule {
  NoModule = 0,
  Admin = 3,
  Default = 12,
  IndexProduct = 16,
  Portfolio = 28,
  UserActivity = 39,
  Data_CreateRDS = 43,
  Analysis_Reports = 48,
  Analysis_Reports_Excel = 49,
  Analysis_Reports_Advanced = 50,
  Analysis_Reports_BasisRisk = 51,
  AccountSettings = 52,
  Analysis_AdvancedLayerFeatures = 53,
  Analysis_Reports_CSVData = 54,
  Portfolio_LayerByRegion = 57,
  Portfolio_Reprocess = 60,
  Portfolio_MarginalReport = 61,
  Portfolio_ELT = 62,
  Admin_AccountManager = 65,
  Admin_CompanyAdmin = 66,
  Company_Member = 67,
  Beta_Features = 68,
  Analysis_Reports_LRP = 69,
  InternalTesting = 71,
  Analysis_Reports_MarginalByRegion = 73,
  PortfolioRetro = 74,
  ReportingPlatformExport = 75,
  LossFileAdjustment_DayOfYear = 77,
  TigerOperationsAccess = 78,
  ELT_Methodology = 79,
  Data_PolicyCorrelation = 80,
  EntityPortfolio = 81,
  QuotaShare = 82,
  PortfolioLossExperience = 83,
  LossSplit = 84,
  ClusterMapping = 85
}

export enum LogoutReasons {
    SecurityModule = 1,
    HasPermission = 2,
    LoginAccessDenied = 3,
    ShowForgotPwdPage = 4,
    OktaTokenExpired = 5,
    IncorrectPasswordUser = 6,
    OktaTokenRenewError = 7,
    OktaTokenExpiredNoCodes = 8,
    ForcePasswordReset = 9
}

export enum AccountSettingGuidType {
  PasswordReset = 'Password Reset',
  AccountActivation = 'Account Activation'
}

export enum AccountSettingID {
  IncludeZeroLossesRDS = 1,
  UseContractDatesForRDS = 2,
  PreventCustomPortfolioLayerTags = 3,
  ShowELTMeanRDS = 4,
}


